import { IMultiSelectOption } from '../../interfaces/ILookup';
import { SelectDropdownUserSetting } from './SelectDropdownUserSetting';
import { UserSettingTypesEnum } from '../../utilities/Constants';
import { useAuthContext } from '../../contexts/AuthContext';

export function PreferredOrganization() {
    const { user } = useAuthContext();

    const options: IMultiSelectOption[] =
        user.organizationRoles?.map(
            (org) =>
                ({
                    guid: org.guid,
                    value: org.guid,
                    label: org.displayName,
                }) as IMultiSelectOption
        ) ?? [];

    return (
        <SelectDropdownUserSetting
            helpText={'TBD'}
            helpTitle={'Preferred Zone'}
            label={'Preferred Zone'}
            options={options}
            settingType={UserSettingTypesEnum.PreferredZone}
        />
    );
}
